import * as api from "../apis/adGroupTemplatesApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getAdGroupTemplatesQueryOptions = () =>
  queryOptions({
    queryKey: ["adGroupTemplates"],
    queryFn: api.getAdGroupTemplates,
    refetchOnWindowFocus: "always",
    
  });

export const getAdGroupTemplatesBySetupTemplateQueryOptions = (
  setupTemplateId,
  queryClient
) =>
  queryOptions({
    queryKey: ["setupTemplate.adGroupTemplates", setupTemplateId],
    queryFn: () => api.getAdGroupTemplatesBySetupTemplate(setupTemplateId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["adGroupTemplates"])
        ?.filter((adGroupTemplate) => adGroupTemplate.setupTemplate.id === setupTemplateId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["adGroupTemplates"])?.dataUpdatedAt,
  });

export const getAdGroupTemplateQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["adGroupTemplate", id],
    queryFn: () => api.getAdGroupTemplate(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "adGroupTemplates" query exist, we use it to init data
      if (queryClient.getQueryState(["adGroupTemplates"])) {
        queryKey = ["adGroupTemplates"];
        return queryClient
          .getQueryData(["adGroupTemplates"])
          ?.find((adGroupTemplate) => adGroupTemplate.id === id);
      }

      // otherwise, we try to find the adGroupTemplate in one of the "account.adGroupTemplates" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["account.adGroupTemplates"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((adGroupTemplate) => {
            if (adGroupTemplate.id === id) {
              found = adGroupTemplate;
              queryKey = query[0];
            }
          });
        });

      // otherwise, we try to find the adGroupTemplate in one of the "setupTemplate.adGroupTemplates" queries
      if (!found) {
        queryClient
          .getQueriesData({ queryKey: ["setupTemplate.adGroupTemplates"] })
          .forEach((query) => {
            const data = query[1];
            data.forEach((adGroupTemplate) => {
              if (adGroupTemplate.id === id) {
                found = adGroupTemplate;
                queryKey = query[0];
              }
            });
          });
      }

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetAdGroupTemplatesBySetupTemplate = (setupTemplateId) => {
  const queryClient = useQueryClient();
  return useQuery(
    getAdGroupTemplatesBySetupTemplateQueryOptions(setupTemplateId, queryClient)
  );
};

export const useGetAdGroupTemplate = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getAdGroupTemplateQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetAdGroupTemplates = () =>
  useSuspenseQuery(getAdGroupTemplatesQueryOptions());

export const useSuspenseGetAdGroupTemplatesBySetupTemplate = (setupTemplateId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(
    getAdGroupTemplatesBySetupTemplateQueryOptions(setupTemplateId, queryClient)
  );
};

export const useSuspenseGetAdGroupTemplate = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getAdGroupTemplateQueryOptions(id, queryClient));
};
